import React, { Component } from 'react';
import $j from 'jquery';
import c from 'classnames';
import windowSize from 'helper/WindowResize';
import Dotdotdot from 'react-dotdotdot';

const blockClose = 'blocks-accordion__item blocks-accordion__item--closed';
const blockOpen = 'blocks-accordion__item';
const hideHtml = 'blocks-accordion__content';
const showHtml = 'blocks-accordion__content blocks-accordion__content--will-enter brand-border-acent blocks-accordion__content--visible';
const header = 'blocks-accordion__header brand-border-acent';
const headerm = 'blocks-accordion__headerm brand-border-acent';
const headerBack = 'blocks-accordion__header';
const headermBack = 'blocks-accordion__headerm';
@windowSize
class Accordion extends Component {
  state = {
    visibleSection: [],
    lessonId: this.props.lesson.id
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lesson.id !== prevState.lessonId) {
      return {
        visibleSection: [],
        lessonId: nextProps.lesson.id
      };
    }
    return null;
  }

  componentWillUnmount() {
    $j(this.htmlRef).off('click.external');
  }

  setHtmlRef = (ref) => {
    this.htmlRef = ref;
    $j(this.htmlRef).off('click.external');
    $j(this.htmlRef).on('click.external', 'a', (e) => {
      e.preventDefault();
      window.open(e.currentTarget.getAttribute('href'));
    });
  };

  showFront = index => () => {
    // alert(index);
    const temparry = this.state.visibleSection;
    temparry.push(index);
    this.setState({
      visibleSection: temparry
    });
  };

  showBack = index => () => {
    const temparry1 = this.state.visibleSection;

    const tempIndex = temparry1.indexOf(index);
    if (tempIndex > -1) {
      temparry1.splice(tempIndex, 1);
    }
    this.setState({
      visibleSection: temparry1
    });
  };

  render() {
    const items = this.props.lesson.items;
    const editable = this.props.editable;
    // console.log(items);
    return (
      <div className="block__content">
        <div className="blocks-accordion" style={{ paddingTop: '30px', paddingBottom: '30px' }}>
          <div className="blocks-accordion__container">
            <div className="blocks-accordion__row">
              <div aria-label="Accordion" className="blocks-accordion__col">
                <div className="blocks-accordion__wrapper">
                  {items.map((item, index) => (
                    <section
                      className={
                        this.state.visibleSection.indexOf(index) > -1 ? blockOpen : blockClose
                      }
                    >
                      {this.state.visibleSection.indexOf(index) > -1 ? (
                        <div role="button" tabIndex="-1" onClick={this.showBack(index)}>
                          <div
                            aria-controls="panel-cjp3nb1z000013h60sgyiiczl"
                            aria-expanded="false"
                            aria-labelledby="title-cjp3nb1z000013h60sgyiiczl"
                            className={this.props.windowWidth < 767 ? headerm : header}
                            // className="blocks-accordion__header brand-border-acent"
                            role="button"
                            tabIndex="-1"
                          >
                            <div className="blocks-accordion__title brand--head brand--linkColor">
                              {item.heading}
                            </div>

                            {this.state.visibleSection.indexOf(index) > -1 ? (
                              <span
                                className="blocks-accordion__toggler"
                                role="button"
                                tabIndex="-1"
                                onClick={this.showBack(index)}
                              >
                                -
                              </span>
                            ) : (
                              <span
                                className="blocks-accordion__toggler"
                                role="button"
                                tabIndex="-1"
                                onClick={this.showFront(index)}
                              >
                                +
                              </span>
                            )}
                          </div>
                        </div>
                      ) : (
                        <div role="button" tabIndex="-1" onClick={this.showFront(index)}>
                          <div
                            aria-controls="panel-cjp3nb1z000013h60sgyiiczl"
                            aria-expanded="false"
                            aria-labelledby="title-cjp3nb1z000013h60sgyiiczl"
                            // className="blocks-accordion__header"
                            className={this.props.windowWidth < 767 ? headermBack : headerBack}
                            role="button"
                            tabIndex="-1"
                          >
                            <div className="blocks-accordion__title brand--head brand--linkColor">
                            <Dotdotdot clamp={3}>{item.heading}</Dotdotdot>
                            </div>

                            {this.state.visibleSection.indexOf(index) > -1 ? (
                              <span
                                className="blocks-accordion__toggler"
                                role="button"
                                tabIndex="-1"
                                onClick={this.showBack(index)}
                              >
                                -
                              </span>
                            ) : (
                              <span
                                className="blocks-accordion__toggler"
                                role="button"
                                tabIndex="-1"
                                onClick={this.showFront(index)}
                              >
                                +
                              </span>
                            )}
                          </div>
                        </div>
                      )}

                      <section
                        aria-labelledby="title-cjp3nb1z000013h60sgyiiczl"
                        className={
                          this.state.visibleSection.indexOf(index) > -1 ? showHtml : hideHtml
                        }
                        id="panel-cjp3nb1z000013h60sgyiiczl"
                      >
                        <div className="brand--linkColor blocks-accordion__description brand--body brand--linkColor">
                          <div className="fr-box fr-inline" role="application">
                            <div className="fr-wrapper" dir="auto">
                              <div className="fr-element fr-view" dir="auto">
                                <div
                                  className={c('redactor-container', {
                                    editable,
                                    preview: !editable
                                  })}
                                  style={{ paddingTop: '0px', paddingBottom: '0px' }}
                                >
                                  <div
                                    ref={this.setHtmlRef}
                                    className="redactor-styles redactor-in htmlFamilyContainer"
                                    dangerouslySetInnerHTML={{ __html: item.html }}
                                  />
                                </div>
                              </div>
                              {/* <span className="fr-placeholder" style="font-size: 16px; line-height: 24px; margin-top: 0px; padding-top: 0px; padding-left: 0px; margin-left: 0px; padding-right: 0px; margin-right: 0px; text-align: start;">Add
                        a description</span> */}
                            </div>
                            {/* <span className="fr-counter" style="bottom: 0px; margin-right: 0px;">248</span> */}
                          </div>
                          {/* <textarea style="display: none;"></textarea> */}
                        </div>

                        {/* <div className="blocks-accordion__media blocks-accordion__image">
                  <div className="media-group">
                    <figure className="figure-image"><img tabindex="0" src="https://images.articulate.com/f:jpg|png,a:retain,b:fff/assets/rise/assets/block-defaults/paraglide.jpg"
                        className="figure-image__image" style="cursor: zoom-in;"></figure>
                  </div>
                </div> */}
                      </section>
                    </section>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Accordion;
